import { FileOutlined } from "@ant-design/icons";
import { RedirectPage } from "components/UI/RedirectPage/RedirectPage";
import { Route as ApiLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/api-old";
import { Route as ClickLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/click";
import { Route as ConversionLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/conversion";
import { Route as LeadLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/lead";
import { Route as StructureLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/structure";
import { Route as TrackingLogsPage } from "routes/_authenticated/$tenantSlug/_layout/log/_layout/tracking";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/log/")({
    component: LogsPage,
    staticData: {
        permissions: [
            PermissionEnum.ApiLogsView,
            PermissionEnum.ConnectionSequenceStepLogsView,
            PermissionEnum.ConversionClickLogView,
            PermissionEnum.ConversionLeadLogView,
            PermissionEnum.CascadeLogView,
            PermissionEnum.ConversionConversionLogView,
            PermissionEnum.StructureLogsView,
            PermissionEnum.OutgoingPostbackView,
            PermissionEnum.IncomingPostbackView,
            PermissionEnum.StepLogIntegrationsView,
        ],
        showInSideMenu: true,
        label: "pages.log.title",
        icon: <FileOutlined />,
        sort: 8,
        redirects: [ClickLogsPage, LeadLogsPage, ConversionLogsPage, ApiLogsPage, StructureLogsPage, TrackingLogsPage],
        defaultRedirect: ClickLogsPage,
    },
});

function LogsPage() {
    return <RedirectPage />;
}
